// extracted by mini-css-extract-plugin
export default {"options":"Options_options__z9naP","deleteButton":"Options_deleteButton__65-Of"};